module.exports = __webpack_public_path__ + "static/media/Level2espanol.c14a13ee.svg";